import Nullstack from 'nullstack';
export default function IconSkateboardOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-skateboard-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "7",
    cy: "15",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M15 15a2 2 0 0 0 2 2m2 -2a2 2 0 0 0 -2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M3 9c0 .552 .895 1 2 1h5m4 0h5c1.105 0 2 -.448 2 -1"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}